// Lib

import { findWithRegex } from '../../../../../../../node_module_clones/draft-js-plugins/utils/findWithRegex';

export default (contentBlock, callback, contentState) =>
    findWithRegex(
        new RegExp('(t|type|elementType|c|color|colour|creator|before|after):([^ ]+)', 'gi'),
        contentBlock,
        callback,
    );
